import { mountVendorWindowEvent } from '../../mountVendorWindowEvent';
import { hashPii } from '../../utils/hashPii';

import { US_COUNTRY_CODE } from './constants';

import type {
  TikTokEvent,
  TikTokHashedData,
  TikTokIdentifyData,
} from './types';

interface TrackTiktokEventArgs {
  eventName: TikTokEvent;
  properties: Record<string, unknown>;
  identifyData: TikTokIdentifyData;
}
async function _mountTikTokEvent(
  window: Window,
  { eventName, properties, identifyData }: TrackTiktokEventArgs
) {
  if (window.ttq) {
    try {
      const hashedData = await hashTikTokData(identifyData);
      window.ttq.identify(hashedData);
      window.ttq.track(eventName, properties);
    } catch {
      window.ttq.track(eventName, properties);
    }
  }
}

export const mountTikTokEvent = mountVendorWindowEvent(
  'TikTok',
  _mountTikTokEvent
);

async function hashTikTokData(
  data: TikTokIdentifyData
): Promise<TikTokHashedData> {
  const hashedData: TikTokHashedData = {};

  if (data.email) {
    hashedData.sha256_email = await hashPii(data.email);
  }

  if (data.phone) {
    hashedData.sha256_phone_number = await hashPii(
      `+${US_COUNTRY_CODE}${data.phone}`
    );
  }

  return hashedData;
}
